const InvMatchMode = {
  ALL: 'all',
  NULL: 'null',
  NOT_NULL: 'notNull',
  EQUAL: 'equal',
}

export default InvMatchMode;